import { IncomeKbn } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

// 請求者区分が退職者本人の場合
const retireeStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 請求者区分が相続人の場合
const heirStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "受給権者確認添付書類",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411112_01,
  },
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "就労年月日",
    keyword: "EmployedDate",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    requiredIcon: true,
  },
  {
    title: "退職年月日",
    keyword: "RetiredDate",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
  },
  {
    title: "区分",
    keyword: "Kbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    requiredIcon: true,
  },
  {
    title: "支払金額",
    keyword: "PaymentAmt",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
  },
  {
    title: "源泉徴収額",
    keyword: "WithholdingAmt",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
  },
  {
    title: "特別徴収税額：市町村民税",
    keyword: "ScAmtCity",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
  },
  {
    title: "特別徴収税額：都道府県税",
    keyword: "ScAmtPrefecture",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
  },
  {
    title: "勤続年数",
    keyword: "LengthOfService",
    type: "amount",
    innerText: "年",
    requiredIcon: true,
    inputProps: { maxLength: 2 },
  },
  {
    title: "退職所得の源泉徴収票",
    keyword: "withholdingFile",
    type: "fileUpload",
    requiredIcon: true,
  },
  {
    title: "重複勤続年数",
    keyword: "duplicationLosYear",
    type: "inputWithText",
    innerText: "年",
    onlyNumber: true,
    useNumberValue: true,
    showLine: false,
    inputProps: { maxLength: 2, style: { textAlign: "end" } },
  },
  {
    title: "重複期間",
    keyword: "duplicationLos",
    type: "durationPicker",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    showLine: false,
    round: "floorAdd",
  },
  {
    title: "控除期間（年）",
    keyword: "deductionPeriodYear",
    type: "amount",
    innerText: "年",
    requiredIcon: true,
    inputProps: { maxLength: 2 },
    explanatoryInTitle:
      "　※控除期間は勤続年数に含まれない期間（差し引かれる期間）がある場合、主に退職所得の源泉徴収票の「摘要」欄に記載があります。\n　記載がない場合は、控除期間が「無い」ということですので、控除期間（年）（月）には「０」を入力してください。",
  },
  {
    title: "控除期間（月）",
    keyword: "deductionPeriodMonth",
    type: "amount",
    innerText: "月",
    requiredIcon: true,
    inputProps: { maxLength: 2 },
    explanatoryInTitle:
      "　※控除期間は勤続年数に含まれない期間（差し引かれる期間）がある場合、主に退職所得の源泉徴収票の「摘要」欄に記載があります。\n　記載がない場合は、控除期間が「無い」ということですので、控除期間（年）（月）には「０」を入力してください。",
  },
];

const schema: any = {
  EmployedDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  RetiredDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  Kbn: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  PaymentAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999"),
    },
  },
  WithholdingAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999"),
    },
  },
  ScAmtCity: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999"),
    },
  },
  ScAmtPrefecture: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999,999,999"),
    },
  },
  LengthOfService: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  withholdingFile: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  deductionPeriodYear: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionPeriodMonth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
};

export { retireeStepper, heirStepper, fakeTableList, schema };
